import { atom } from 'recoil';
import TicketLayout from '../entities/TicketLayout';


const ticketLayoutState = atom<TicketLayout>({
  key: 'ticketLayoutState',
  default: {
    name: 'default',
    fieldCodes: [],
    requiredCodes: []
  } as TicketLayout
});

export const getDefaultLayout = () => {
  return {
    name: 'default',
    fieldCodes: [],
    requiredCodes: []
  } as TicketLayout
}

export default ticketLayoutState;